export const dataCamara = [

    {
        question: "O que é um vereador?",
        answer: "O vereador é o representante eleito pelo povo para exercer o mandato legislativo no âmbito municipal, com duração de 4 anos. Suas atribuições incluem: propor e votar projetos de lei, fiscalizar a administração pública municipal, apresentar requerimentos e indicações ao Executivo, participar das sessões plenárias e das comissões da Câmara. O vereador possui imunidade parlamentar no exercício de suas funções, mas não recebe a mesma amplitude de imunidades que deputados federais ou senadores. O número de vereadores varia conforme o tamanho do município, sendo determinado pela Constituição Federal.",
        link: null,
        keywords: ["vereador", "o que e vereador", "funcao do vereador", "mandato vereador", "representante municipal"]
    },
    {
        question: "O que é a Mesa Diretora da Câmara?",
        answer: "A Mesa Diretora é o órgão responsável pela direção dos trabalhos legislativos e administrativos da Câmara Municipal. É composta geralmente pelo Presidente, Vice-Presidente, 1º Secretário e 2º Secretário, eleitos pelos próprios vereadores no início de cada legislatura. O Presidente da Câmara preside as sessões, representa a Câmara externamente e pode assumir a chefia do Executivo em casos de impedimento simultâneo do Prefeito e do Vice-Prefeito.",
        link: "/mesadiretora",
        keywords: ["mesa diretora", "presidente da camara", "direcao da camara", "secretario camara", "vice presidente camara"]
    },
    {
        question: "O que é uma sessão plenária?",
        answer: "A sessão plenária é a reunião formal de todos os vereadores para deliberar sobre matérias legislativas, como votação de projetos de lei, requerimentos, indicações e outros assuntos de competência da Câmara. As sessões podem ser: Ordinárias (realizadas regularmente conforme calendário definido no Regimento Interno), Extraordinárias (convocadas fora do calendário para tratar de assuntos urgentes) e Solenes (realizadas para homenagens, comemorações ou eventos especiais). Em regra, as sessões são abertas ao público.",
        link: null,
        keywords: ["sessao plenaria", "reuniao camara", "votacao vereadores", "sessao ordinaria", "sessao extraordinaria"]
    },
    {
        question: "O que é um Projeto de Lei Municipal?",
        answer: "Um Projeto de Lei (PL) é uma proposta formal apresentada à Câmara Municipal com o objetivo de criar, alterar ou revogar uma lei municipal. Podem apresentar projetos de lei: os vereadores, o Prefeito Municipal e, em alguns casos, os próprios cidadãos (por meio de iniciativa popular, quando subscrito por um percentual mínimo de eleitores definido na Lei Orgânica). Após apresentado, o projeto passa por comissões para análise e, em seguida, vai a votação no plenário. Se aprovado, é enviado ao Prefeito para sanção ou veto.",
        link: "/legislacao/projetodelei",
        keywords: ["projeto de lei", "pl", "como nasce uma lei", "proposta legislativa", "iniciativa popular"]
    },
    {
        question: "O que é a Lei Orgânica Municipal?",
        answer: "A Lei Orgânica Municipal é a lei fundamental do município, equivalente à 'Constituição Municipal'. Ela estabelece a organização, as competências e o funcionamento do governo local, definindo as regras para o Poder Executivo (Prefeitura) e o Poder Legislativo (Câmara). Foi elaborada pela própria Câmara Municipal e deve respeitar a Constituição Federal e a Constituição Estadual. Qualquer lei municipal que contrarie a Lei Orgânica pode ser declarada inconstitucional.",
        link: "/legislacao/leiorganica",
        keywords: ["lei organica", "constituicao municipal", "lei fundamental municipio", "o que e lei organica"]
    },
    {
        question: "O que é uma Moção?",
        answer: "A moção é um instrumento legislativo utilizado pela Câmara Municipal para manifestar formalmente sua posição sobre determinado assunto. Pode ser de: Louvor ou Congratulações (homenagem a pessoas, entidades ou acontecimentos), Repúdio (manifestação contrária a algum ato ou situação), Apoio (para manifestar solidariedade a causas ou iniciativas) ou Apelo (para solicitar providências a outras autoridades ou poderes). As moções não têm força de lei, mas representam a posição oficial do Legislativo municipal.",
        link: "/legislacao/mocoes",
        keywords: ["mocao", "o que e mocao", "homenagem camara", "mocao de louvor", "mocao de repudio"]
    },
    {
        question: "O que é um Requerimento na Câmara?",
        answer: "O requerimento é um instrumento pelo qual o vereador solicita informações, documentos ou providências à Câmara ou ao Poder Executivo. Existem diferentes tipos: Requerimento de Informação (solicita dados e esclarecimentos ao Executivo), Requerimento de Urgência (pede tramitação mais rápida de uma matéria), Requerimento de Convocação (para convocar secretários municipais a prestar esclarecimentos na Câmara) e Requerimento Simples (para assuntos internos da Casa). É um importante instrumento de fiscalização dos vereadores.",
        link: "/legislacao/requerimentos",
        keywords: ["requerimento camara", "o que e requerimento", "pedido de informacao vereador", "requerimento de informacao"]
    },
    {
        question: "O que é o Controle Interno da Câmara?",
        answer: "O Controle Interno é um sistema de fiscalização exercido dentro da própria Câmara Municipal para garantir a legalidade, eficiência e transparência na gestão dos recursos públicos. Ele verifica se os gastos estão de acordo com o orçamento aprovado, se os processos licitatórios seguem as normas legais e se os atos administrativos estão em conformidade com a legislação. O Controle Interno é obrigatório por lei e trabalha de forma integrada com o Tribunal de Contas para assegurar a boa aplicação do dinheiro público.",
        link: "/legislacao/controleinterno",
        keywords: ["controle interno", "fiscalizacao camara", "auditoria camara", "controle interno legislativo"]
    },
    {
        question: "O que é o E-SIC da Câmara?",
        answer: "O E-SIC (Sistema Eletrônico do Serviço de Informação ao Cidadão) da Câmara Municipal é o canal oficial para que qualquer cidadão solicite informações e documentos públicos relacionados à atividade legislativa. Por meio do E-SIC, você pode pedir: atas de sessões, votações de vereadores, contratos, despesas, remunerações e qualquer outro dado de interesse público. O atendimento é gratuito e deve respeitar os prazos previstos na Lei de Acesso à Informação (LAI). Acesse pelo link abaixo.",
        link: "/e-sic",
        keywords: ["e-sic camara", "servico de informacao camara", "pedir informacao camara", "sic legislativo"]
    },
    {
        question: "O que são comissões permanentes da Câmara?",
        answer: "As comissões permanentes são grupos de vereadores organizados de forma estável para analisar e emitir parecer sobre projetos de lei e outros assuntos relacionados a temas específicos, como finanças, saúde, educação e obras. Antes de ir ao plenário, um projeto de lei geralmente passa pelas comissões competentes, que avaliam sua constitucionalidade, legalidade e mérito. Além das comissões permanentes, podem ser criadas Comissões Especiais ou Comissões Parlamentares de Inquérito (CPIs) para investigar fatos determinados.",
        link: null,
        keywords: ["comissao permanente", "comissao camara", "cpi camara", "comissao de financas", "comissao especial"]
    },
    {
        question: "O que é uma CPI Municipal?",
        answer: "A Comissão Parlamentar de Inquérito (CPI) Municipal é instaurada pela Câmara para investigar fatos determinados de interesse público local, como suspeitas de irregularidades na administração municipal. A CPI tem poderes investigativos próprios: pode convocar testemunhas, requisitar documentos e realizar diligências. Ao final dos trabalhos, elabora um relatório conclusivo que pode resultar em encaminhamento às autoridades competentes (Ministério Público, Tribunal de Contas, etc.) para as providências cabíveis. É um importante instrumento de fiscalização popular.",
        link: null,
        keywords: ["cpi municipal", "comissao parlamentar de inquerito", "investigacao camara", "cpi camara municipal"]
    },
    {
        question: "Licitações",
        answer: "Veja informações sobre Licitações pelo link abaixo.",
        link: "/licitacoes",
        keywords: ["licitacoes", "concorrencia", "pregao", "processo licitatorio", "contratos"]
    },
    {
        question: "Mesa Diretora",
        answer: "Saiba mais sobre a Mesa Diretora pelo link abaixo.",
        link: "/mesadiretora",
        keywords: ["mesa diretora", "presidencia", "camara", "vereadores", "direcao"]
    },
    {
        question: "Diários Oficiais",
        answer: "Consulte os Diários Oficiais pelo link abaixo.",
        link: "/legislacao/diariosoficial",
        keywords: ["diarios oficiais", "publicacoes", "atos", "camara", "documentos"]
    },
    {
        question: "Requerimentos",
        answer: "Acesse os Requerimentos através do link abaixo.",
        link: "/legislacao/requerimentos",
        keywords: ["requerimentos", "pedidos", "documentos", "solicitacoes", "processos"]
    },
    {
        question: "Código Tributário",
        answer: "Consulte o Código Tributário Municipal pelo link abaixo.",
        link: "/legislacao/codigotributario",
        keywords: ["codigo tributario", "tributos", "impostos", "municipal", "legislacao"]
    },
    {
        question: "Projetos de Lei",
        answer: "Veja os Projetos de Lei Municipais no link abaixo.",
        link: "/legislacao/projetodelei",
        keywords: ["projetos de lei", "legislacao", "camara", "leis", "projetos"]
    },
    {
        question: "Lei Orgânica",
        answer: "Acesse a Lei Orgânica Municipal pelo link abaixo.",
        link: "/legislacao/leiorganica",
        keywords: ["lei organica", "legislacao", "municipal", "fundamento legal", "camara"]
    },
    {
        question: "Transparência",
        answer: "Veja informações de transparência no link abaixo.",
        link: "/transparencia",
        keywords: ["transparencia", "financas", "dados publicos", "municipal", "orcamento"]
    },
    {
        question: "Avisos",
        answer: "Confira os avisos mais recentes pelo link abaixo.",
        link: "/avisos",
        keywords: ["avisos", "comunicados", "informacoes", "notificacoes", "municipal"]
    },
    {
        question: "Contratos",
        answer: "Veja os contratos públicos no link abaixo.",
        link: "/arquivos/contratos",
        keywords: ["contratos", "licitacoes", "documentos", "publicos", "acordos"]
    },
    {
        question: "Editais",
        answer: "Acesse os editais pelo link abaixo.",
        link: "/arquivos/editais",
        keywords: ["editais", "documentos", "concorrencia", "processos", "licitacoes"]
    },
    {
        question: "E-SIC",
        answer: "Envie suas solicitações pelo E-SIC através do link abaixo.",
        link: "/e-sic",
        keywords: ["e-sic", "solicitacoes", "informacoes", "acesso publico", "servicos"]
    },
    {
        question: "História",
        answer: "Leia sobre a história da cidade no link abaixo.",
        link: "/historia",
        keywords: ["historia", "municipio", "origem", "cultura"]
    },
    {
        question: "Ouvidoria",
        answer: "Envie sua mensagem pela Ouvidoria no link abaixo.",
        link: "/ouvidoria",
        keywords: ["ouvidoria", "reclamacoes", "sugestoes", "contato", "municipio"]
    },
    {
        question: "Decretos",
        answer: "Veja os decretos municipais no link abaixo.",
        link: "/legislacao/decretos",
        keywords: ["decretos", "legislacao", "municipal", "documentos", "camara"]
    },
    {
        question: "Mocões",
        answer: "Consulte as moções disponíveis pelo link abaixo.",
        link: "/legislacao/mocoes",
        keywords: ["mocoes", "camara", "reconhecimento", "legislacao", "documentos"]
    },
    {
        question: "Leis Municipais",
        answer: "Veja as leis municipais pelo link abaixo.",
        link: "/legislacao/leismunicipais",
        keywords: ["leis municipais", "legislacao", "camara", "documentos", "municipal"]
    },
    {
        question: "Controle Interno",
        answer: "Consulte informações sobre Controle Interno no link abaixo.",
        link: "/legislacao/controleinterno",
        keywords: ["controle interno", "auditoria", "camara", "municipal", "gestao"]
    },
    {
        question: "Tabela de Diárias",
        answer: "Veja a tabela de diárias pelo link abaixo.",
        link: "/arquivos/tabela-diarias",
        keywords: ["tabela de diarias", "gestao", "financas", "documentos", "camara"]
    },
    {
        question: "PCA",
        answer: "Consulte o Plano de Contas Anual no link abaixo.",
        link: "/arquivos/pca",
        keywords: ["pca", "plano de contas", "orcamento", "gestao", "camara"]
    },
    {
        question: "Frota",
        answer: "Veja informações sobre a frota pelo link abaixo.",
        link: "/arquivos/frota",
        keywords: ["frota", "veiculos", "gestao", "municipal", "camara"]
    },
    {
        question: "Quadro de Servidores",
        answer: "Consulte o quadro de servidores no link abaixo.",
        link: "/arquivos/quadro",
        keywords: ["quadro de servidores", "funcionarios", "municipal", "camara", "gestao"]
    },

];

export const prefeitura = [
    {
        question: 'Início',
        answer: 'Esta é a página inicial do portal. Clique no link abaixo para acessar.',
        link: '/',
        keywords: ['inicio', 'home', 'pagina inicial', 'abertura', 'principal'],
    },
    {
        question: "E-SIC",
        answer: "Envie suas solicitações pelo E-SIC através do link abaixo.",
        link: "/e-sic",
        keywords: ["e-sic", "solicitacoes", "informacoes", "acesso publico", "servicos"]
    },
    {
        question: 'Notícias',
        answer: 'Confira as últimas notícias acessando o link abaixo.',
        link: '/noticias/todas',
        keywords: ['noticias', 'novidades', 'informacoes', 'jornal', 'acontecimento'],
    },
    {
        question: 'Notícia',
        answer: 'Confira a notícia completa.',
        link: '/noticias/:titulo/:id',
        keywords: ['noticia', 'informacoes', 'conteudo', 'atualidades'],
    },
    {
        question: 'Transparência',
        answer: 'Confira as informações sobre a transparência da administração pública.',
        link: '/transparencia',
        keywords: ['transparencia', 'governo', 'informacoes publicas', 'administracao'],
    },
    {
        question: 'Avisos',
        answer: 'Acesse os avisos mais recentes da Prefeitura.',
        link: '/avisos',
        keywords: ['avisos', 'comunicados', 'notificacoes', 'anuncios'],
    },
    {
        question: 'Legislação',
        answer: 'Consulte as leis e documentos legais da Prefeitura.',
        link: '/legislacao/leismunicipais',
        keywords: ['legislacao', 'leis', 'requerimentos'],
    },
    {
        question: 'Código Tributário',
        answer: 'Acesse o Código Tributário do Município.',
        link: '/legislacao/codigotributario',
        keywords: ['codigo tributario', 'tributacao', 'impostos', 'financas municipais'],
    },
    {
        question: 'Decretos',
        answer: 'Veja os decretos municipais disponíveis.',
        link: '/legislacao/decretos',
        keywords: ['decretos', 'documentos oficiais', 'regulamentacoes'],
    },
    {
        question: 'Diário Oficial',
        answer: 'Acesse o Diário Oficial do Município.',
        link: '/legislacao/diariosoficial',
        keywords: ['diario oficial', 'publicacoes', 'documentos', 'noticias oficiais'],
    },
    {
        question: 'Requerimentos',
        answer: 'Consulte os requerimentos realizados.',
        link: '/legislacao/requerimentos',
        keywords: ['requerimentos', 'solicitacoes', 'documentos oficiais'],
    },
    {
        question: 'Lei Orgânica',
        answer: 'Acesse a Lei Orgânica do Município.',
        link: '/legislacao/leiorganica',
        keywords: ['lei organica', 'constituição municipal'],
    },
    {
        question: 'Mocões',
        answer: 'Consulte as moções disponíveis.',
        link: '/legislacao/mocoes',
        keywords: ['mocoes', 'propostas', 'legislacao'],
    },
    {
        question: 'Pedidos de Informação',
        answer: 'Acesse os pedidos de informação realizados.',
        link: '/legislacao/pedidos_info',
        keywords: ['pedidos de informacao', 'solicitacoes', 'documentos'],
    },
    {
        question: 'Leis Municipais',
        answer: 'Consulte as leis municipais em vigor.',
        link: '/legislacao/leismunicipais',
        keywords: ['leis municipais', 'regulamentos', 'documentos legais'],
    },
    {
        question: 'Portarias',
        answer: 'Veja as portarias municipais.',
        link: '/legislacao/portarias',
        keywords: ['portarias', 'documentos administrativos'],
    },
    {
        question: 'Controle Interno',
        answer: 'Acesse as informações sobre o controle interno da Prefeitura.',
        link: '/legislacao/controleinterno',
        keywords: ['controle interno', 'auditoria', 'gestao pública'],
    },
    {
        question: 'Licitacoes',
        answer: 'Consulte as licitações públicas da Prefeitura.',
        link: '/licitacoes',
        keywords: ['licitacoes', 'concursos', 'contratos publicos'],
    },
    {
        question: 'Arquivos Públicos',
        answer: 'Acesse editais, contratos e outros documentos públicos.',
        link: '/arquivos/editais',
        keywords: ['arquivos', 'documentos publicos', 'editais', 'contratos'],
    },
    {
        question: 'Editais',
        answer: 'Consulte os editais de concursos e outros processos.',
        link: '/arquivos/editais',
        keywords: ['editais', 'processos seletivos', 'concursos'],
    },
    {
        question: 'Contratos',
        answer: 'Acesse os contratos públicos celebrados.',
        link: '/arquivos/contratos',
        keywords: ['contratos', 'documentos publicos', 'acordos'],
    },
    {
        question: 'LDO',
        answer: 'Acesse a Lei de Diretrizes Orçamentárias.',
        link: '/arquivos/ldo',
        keywords: ['ldo', 'orçamento', 'financas públicas'],
    },
    {
        question: 'LOA',
        answer: 'Acesse a Lei Orçamentária Anual.',
        link: '/arquivos/loa',
        keywords: ['loa', 'orçamento anual', 'finanças públicas'],
    },
    {
        question: 'RGF',
        answer: 'Consulte o Relatório de Gestão Fiscal.',
        link: '/arquivos/rgf',
        keywords: ['rgf', 'gestao fiscal', 'financas municipais'],
    },
    {
        question: 'Tabela Diárias',
        answer: 'Acesse a tabela de diárias municipais.',
        link: '/arquivos/tabela-diarias',
        keywords: ['tabela diarias', 'diarias', 'despesas publicas'],
    },
    {
        question: 'PCA',
        answer: 'Acesse os planos de ação da Prefeitura.',
        link: '/arquivos/pca',
        keywords: ['pca', 'planos de acao', 'gestao publica'],
    },
    {
        question: 'RREO',
        answer: 'Consulte o Relatório Resumido de Execução Orçamentária.',
        link: '/arquivos/rreo',
        keywords: ['rreo', 'execucao orcamentaria', 'relatorio financeiro'],
    },
    {
        question: 'Frota',
        answer: 'Veja as informações sobre a frota municipal.',
        link: '/arquivos/frota',
        keywords: ['frota', 'veiculos', 'transporte publico'],
    },
    {
        question: 'Quadro de Servidores',
        answer: 'Consulte o quadro de servidores públicos municipais.',
        link: '/arquivos/quadro',
        keywords: ['quadro de servidores', 'funcionarios', 'servidores publicos'],
    },
    {
        question: 'Farmácia Básica',
        answer: 'Acesse informações sobre a farmácia básica da cidade.',
        link: '/arquivos/farmaciabasica',
        keywords: ['farmacia basica', 'saude publica', 'medicamentos'],
    },
    {
        question: 'Secretarias',
        answer: 'Acesse informações das secretarias municipais.',
        link: '/secretarias/financas',
        keywords: ['secretarias', 'financas', 'educacao', 'saude', 'administracao', 'cultura'],
    },
    {
        question: 'Finanças',
        answer: 'Acesse informações sobre a Secretaria de Finanças.',
        link: '/secretarias/financas',
        keywords: ['financas', 'contabilidade', 'tributos', 'orçamento'],
    },
    {
        question: 'Educação',
        answer: 'Acesse informações sobre a Secretaria de Educação.',
        link: '/secretarias/educacao',
        keywords: ['educacao', 'escolas', 'ensino', 'cursos'],
    },
    {
        question: 'Administração',
        answer: 'Acesse informações sobre a Secretaria de Administração.',
        link: '/secretarias/administracao',
        keywords: ['administracao', 'gestao', 'servidores'],
    },
    {
        question: 'Cultura',
        answer: 'Acesse informações sobre a Secretaria de Cultura.',
        link: '/secretarias/cultura',
        keywords: ['cultura', 'arte', 'eventos', 'patrimonio'],
    },
    {
        question: 'Saúde',
        answer: 'Acesse informações sobre a Secretaria de Saúde.',
        link: '/secretarias/saude',
        keywords: ['saude', 'hospitais', 'medicos', 'assistencia'],
    },
    {
        question: 'Meio Ambiente',
        answer: 'Acesse informações sobre a Secretaria de Meio Ambiente.',
        link: '/secretarias/meioambiente',
        keywords: ['meio ambiente', 'ecologia', 'sustentabilidade', 'natureza'],
    },
    {
        question: 'Desenvolvimento Rural',
        answer: 'Acesse informações sobre a Secretaria de Desenvolvimento Rural.',
        link: '/secretarias/desenvolvimentorural',
        keywords: ['desenvolvimento rural', 'agricultura', 'campo'],
    },
    {
        question: 'Assistência Social',
        answer: 'Acesse informações sobre a Secretaria de Assistência Social.',
        link: '/secretarias/assistenciasocial',
        keywords: ['assistencia social', 'beneficios', 'atendimento social'],
    },
    {
        question: 'Recursos Humanos',
        answer: 'Acesse informações sobre o setor de Recursos Humanos.',
        link: '/setor/recursoshumanos',
        keywords: ['recursos humanos', 'contratacoes', 'servidores'],
    },
    {
        question: 'Prefeito',
        answer: 'Informações sobre o Prefeito Municipal.',
        link: '/prefeitura/prefeito',
        keywords: ['prefeito', 'administracao', 'governo local'],
    },
    {
        question: 'Vice-Prefeito',
        answer: 'Informações sobre o Vice-Prefeito Municipal.',
        link: '/prefeitura/viceprefeito',
        keywords: ['vice-prefeito', 'administracao', 'governo local'],
    },
    {
        question: 'LGPD',
        answer: 'Acesso à política de proteção de dados pessoais (LGPD).',
        link: '/lgpd',
        keywords: ['lgpd', 'protecaodedados', 'privacidade'],
    },
    {
        question: 'Carta de Serviço',
        answer: 'Conheça a Carta de Serviço da Prefeitura.',
        link: '/carta-de-servico',
        keywords: ['carta de servico', 'servicos publicos', 'informacoes de servicos'],
    },
    {
        question: 'Ouvidoria',
        answer: 'Acesse a Ouvidoria Municipal para registrar sugestões ou reclamações.',
        link: '/ouvidoria',
        keywords: ['ouvidoria', 'sugestoes', 'reclamacoes', 'atendimento ao publico'],
    },
    {
        question: 'História de Gurjão',
        answer: 'Descubra a história da cidade de Gurjão.',
        link: '/historia',
        keywords: ['historia', 'cidade', 'cultura local'],
    },
    {
        question: 'Galeria de Mídia',
        answer: 'Acesse a galeria de fotos e vídeos da Prefeitura.',
        link: '/galeria',
        keywords: ['galeria', 'fotos', 'videos', 'midia'],
    },

    // ===================== FAQ PREFEITURA — LEI DE ACESSO À INFORMAÇÃO (LAI) =====================

    {
        question: "O que é a LAI (Lei de Acesso à Informação)?",
        answer: "A LAI é a Lei Federal nº 12.527/2011, que garante a qualquer pessoa — física ou jurídica — o direito de solicitar e receber informações públicas dos órgãos e entidades do poder público, incluindo prefeituras e câmaras municipais. A lei estabelece que a publicidade é a regra e o sigilo é a exceção. Com a LAI, o cidadão não precisa explicar o motivo do pedido nem se identificar para acessar a maioria das informações públicas. Ela representa um importante avanço na transparência e no controle social da gestão pública brasileira.",
        link: "/e-sic",
        keywords: ["lai", "lei de acesso a informacao", "lei 12527", "direito a informacao", "o que e lai"]
    },
    {
        question: "É possível a recusa imotivada à prestação de informações?",
        answer: "Não. A Lei de Acesso à Informação (LAI) proíbe expressamente a recusa imotivada de informações. Caso o órgão público negue um pedido, deve apresentar justificativa legal clara e por escrito, indicando o fundamento da negativa. Somente informações classificadas como sigilosas (ultrassecreta, secreta ou reservada), dados pessoais de terceiros ou informações que possam comprometer a segurança do Estado ou de investigações em andamento podem ser negadas, desde que com fundamentação adequada. O cidadão tem direito a recorrer da negativa em até 10 dias corridos.",
        link: "/e-sic",
        keywords: ["recusa de informacao", "negativa de informacao", "recusa imotivada", "negativa lai", "direito negado"]
    },
    {
        question: "Existe prazo para resposta da administração pública?",
        answer: "Sim. A LAI estabelece prazos rigorosos para resposta. O órgão público tem até 20 dias corridos para responder ao pedido de informação, contados a partir do registro da solicitação. Esse prazo pode ser prorrogado por mais 10 dias, desde que haja justificativa expressa comunicada ao solicitante antes do vencimento do prazo inicial. Caso não haja resposta no prazo, o cidadão pode apresentar reclamação à autoridade de monitoramento da LAI ou interpor recurso. O descumprimento dos prazos constitui conduta ilícita passível de responsabilização do servidor.",
        link: "/e-sic",
        keywords: ["prazo resposta lai", "prazo informacao publica", "20 dias lai", "tempo de resposta prefeitura", "prazo sic"]
    },
    {
        question: "Pode haver pedido de solicitação de informação anônimo?",
        answer: "A LAI exige que o solicitante se identifique (nome e algum meio de contato, como e-mail), mas não exige justificativa para o pedido. Portanto, pedidos completamente anônimos não são previstos na lei. No entanto, a identificação é tratada com sigilo pelo órgão público — ela serve apenas para que a resposta seja enviada ao solicitante e não pode ser utilizada para discriminar ou prejudicar quem faz o pedido. Nenhum agente público pode indagar os motivos da solicitação como condição para atender o pedido.",
        link: "/e-sic",
        keywords: ["pedido anonimo", "anonimato lai", "identificacao lai", "precisa identificar lai", "sigilo solicitante"]
    },
    {
        question: "É necessário justificar o pedido de informações?",
        answer: "Não. A Lei de Acesso à Informação (LAI) é explícita: o solicitante não é obrigado a informar os motivos do pedido. Exigir justificativa é uma prática ilegal que contraria os princípios da transparência pública. Qualquer agente público que condicionar o atendimento à apresentação de justificativas pode ser responsabilizado administrativamente. O cidadão precisa apenas se identificar (nome e contato) para que a resposta possa ser enviada, mas o 'porquê' do pedido é irrelevante para o atendimento.",
        link: "/e-sic",
        keywords: ["justificar pedido informacao", "motivo pedido lai", "precisa justificar", "porque pedir informacao", "condicao pedido"]
    },
    {
        question: "Quais informações NÃO podem ser solicitadas via LAI?",
        answer: "A LAI protege algumas categorias de informações que podem ser negadas, como: informações classificadas como sigilosas pelo poder público (ultrassecretas, secretas ou reservadas), dados pessoais de terceiros que possam violar a privacidade de outras pessoas, informações sobre projetos de pesquisa em andamento que possam comprometer sua execução, dados relativos à segurança de autoridades, informações sobre investigações em curso que possam prejudicá-las, e dados cobertos por sigilo fiscal, bancário, médico ou profissional. A negativa deve sempre ser fundamentada e o cidadão pode recorrer.",
        link: "/e-sic",
        keywords: ["informacao sigilosa", "informacao negada", "excecao lai", "sigilo lai", "o que nao pode pedir lai"]
    },
    {
        question: "O que é o E-SIC da Prefeitura?",
        answer: "O E-SIC (Sistema Eletrônico do Serviço de Informação ao Cidadão) é o canal oficial da Prefeitura para receber e responder pedidos de acesso à informação conforme a LAI. Por meio do E-SIC, qualquer cidadão pode registrar solicitações de informações, acompanhar o andamento dos pedidos e receber as respostas — tudo de forma gratuita e online. O sistema garante rastreabilidade e transparência no atendimento. É vedado ao órgão público cobrar qualquer valor pelo fornecimento de informações em formato digital.",
        link: "/e-sic",
        keywords: ["e-sic prefeitura", "sistema informacao cidadao", "sic online", "pedir informacao prefeitura", "acesso informacao online"]
    },
    {
        question: "Como recorrer caso meu pedido de informação seja negado?",
        answer: "Caso seu pedido de informação seja negado ou não respondido no prazo legal, você pode recorrer em até 10 dias corridos da ciência da negativa. O recurso de 1ª instância vai à autoridade hierárquica superior do órgão que negou. Se mantida a negativa, cabe recurso de 2ª instância à autoridade máxima do órgão (Prefeito ou Presidente da Câmara). Em seguida, o cidadão pode acionar o Ministério Público, o Tribunal de Contas ou a Controladoria do Estado. Municípios que tenham aderido ao sistema federal podem ainda recorrer à CGU (Controladoria-Geral da União).",
        link: "/e-sic",
        keywords: ["recurso lai", "recorrer pedido negado", "recurso informacao", "como recorrer lai", "negativa informacao recurso"]
    },
    {
        question: "O acesso à informação pública é gratuito?",
        answer: "Sim, na maioria dos casos. A LAI determina que o acesso à informação é gratuito. No entanto, pode ser cobrado apenas o valor dos custos de reprodução dos documentos — como cópias impressas — desde que não seja possível o fornecimento em formato digital. Nenhuma taxa pode ser cobrada pela busca e processamento da informação em si. Pessoas declaradas pobres, nos termos da lei, têm direito à isenção total dos custos de reprodução. O fornecimento em meio digital deve ser sempre gratuito.",
        link: "/e-sic",
        keywords: ["acesso informacao gratuito", "custo informacao publica", "cobrar lai", "taxa informacao", "informacao de graca"]
    },
    {
        question: "O que é transparência ativa e transparência passiva?",
        answer: "A transparência ativa ocorre quando o órgão público divulga informações de interesse geral de forma proativa, sem que o cidadão precise pedir — como salários, contratos, licitações, despesas e receitas publicadas no Portal da Transparência. Já a transparência passiva acontece quando o cidadão faz um pedido específico de informação via E-SIC ou SIC presencial, e o órgão tem o dever de responder dentro dos prazos legais. A LAI exige os dois tipos: publicação espontânea no portal e atendimento a pedidos individuais dos cidadãos.",
        link: "/transparencia",
        keywords: ["transparencia ativa", "transparencia passiva", "portal transparencia", "diferenca transparencia", "publicacao espontanea"]
    },
    {
        question: "O que é o Portal da Transparência?",
        answer: "O Portal da Transparência é o espaço virtual obrigatório onde a administração pública disponibiliza proativamente dados sobre sua gestão, como: receitas e despesas, folha de pagamento dos servidores, contratos e licitações, convênios, diárias e passagens, obras em andamento e balanços orçamentários. A obrigatoriedade do portal é prevista na Lei de Responsabilidade Fiscal e na LAI, e os dados devem ser atualizados regularmente, em linguagem acessível e de forma a permitir a fiscalização pelos cidadãos e órgãos de controle.",
        link: "/transparencia",
        keywords: ["portal da transparencia", "o que e portal transparencia", "dados publicos", "transparencia prefeitura", "dados governo"]
    },
    {
        question: "O que é a Ouvidoria Municipal?",
        answer: "A Ouvidoria Municipal é o canal de comunicação entre o cidadão e a administração pública para registro de reclamações, denúncias, sugestões, elogios e solicitações de informações. Diferente do E-SIC (que trata de pedidos de acesso à informação), a Ouvidoria tem um papel mais amplo, incluindo a mediação de conflitos e o acompanhamento de demandas da população. As manifestações registradas na Ouvidoria são encaminhadas aos setores competentes e devem ser respondidas dentro de prazos definidos. O serviço é gratuito, sigiloso e pode ser anônimo.",
        link: "/ouvidoria",
        keywords: ["ouvidoria municipal", "o que e ouvidoria", "reclamacao prefeitura", "denuncia prefeitura", "sugestao prefeitura"]
    },
    {
        question: "O que é a LGPD e como ela afeta os dados dos cidadãos?",
        answer: "A LGPD (Lei Geral de Proteção de Dados Pessoais — Lei nº 13.709/2018) regula o tratamento de dados pessoais por órgãos públicos e privados no Brasil. Para a Prefeitura, significa que todos os dados pessoais dos cidadãos coletados nos serviços públicos (saúde, educação, assistência social, etc.) devem ser tratados com finalidade legítima, de forma segura e com transparência. O cidadão tem direito de saber quais dados seus estão sendo usados, pedir correções e, em alguns casos, solicitar a exclusão. A Prefeitura deve ter uma Política de Privacidade e indicar um encarregado pelo tratamento de dados.",
        link: "/lgpd",
        keywords: ["lgpd", "lei de protecao de dados", "dados pessoais prefeitura", "privacidade dados", "o que e lgpd"]
    },
    {
        question: "O que é a Lei de Responsabilidade Fiscal (LRF)?",
        answer: "A Lei de Responsabilidade Fiscal (Lei Complementar nº 101/2000) estabelece normas para a gestão responsável das finanças públicas nos três poderes e nos três níveis de governo (federal, estadual e municipal). Para a Prefeitura, ela impõe limites para gastos com pessoal, dívida pública e operações de crédito, além de exigir o cumprimento de metas fiscais e a publicação periódica de relatórios como o RREO (Relatório Resumido de Execução Orçamentária) e o RGF (Relatório de Gestão Fiscal). O descumprimento pode resultar em punições ao gestor, incluindo cassação de mandato.",
        link: "/arquivos/rgf",
        keywords: ["lei de responsabilidade fiscal", "lrf", "o que e lrf", "lei complementar 101", "responsabilidade fiscal prefeito"]
    },
    {
        question: "O que é o orçamento municipal (LOA)?",
        answer: "O orçamento municipal é formalizado pela LOA (Lei Orçamentária Anual), que estima as receitas e fixa as despesas do município para um exercício financeiro. Ele deve ser elaborado pelo Poder Executivo (Prefeitura) em consonância com o PPA (Plano Plurianual) e a LDO (Lei de Diretrizes Orçamentárias), e enviado à Câmara Municipal para aprovação até 30 de setembro de cada ano. O cidadão pode acompanhar a execução do orçamento por meio do Portal da Transparência, verificando o quanto foi arrecadado e como os recursos estão sendo gastos em cada área.",
        link: "/arquivos/loa",
        keywords: ["orcamento municipal", "loa", "lei orcamentaria anual", "o que e orcamento municipal", "despesas prefeitura"]
    },
    {
        question: "O que é uma licitação pública?",
        answer: "A licitação é o processo obrigatório pelo qual a administração pública seleciona, de forma imparcial e transparente, a proposta mais vantajosa para contratação de obras, serviços, compras e alienações com recursos públicos. As modalidades mais comuns são: Pregão (eletrônico ou presencial), Concorrência, Tomada de Preços e Convite, além do Credenciamento e do Diálogo Competitivo previstos na nova Lei de Licitações (Lei nº 14.133/2021). Todos os editais e resultados devem ser publicados e estão disponíveis para consulta pública.",
        link: "/licitacoes",
        keywords: ["licitacao publica", "o que e licitacao", "pregao", "concorrencia publica", "como funciona licitacao"]
    },
    {
        question: "O que é o Diário Oficial Municipal?",
        answer: "O Diário Oficial Municipal é o veículo de publicação dos atos oficiais da administração pública municipal, como leis, decretos, portarias, contratos, editais de licitação, nomeações, exonerações e outros atos administrativos. A publicação no Diário Oficial confere publicidade e validade jurídica aos atos, garantindo que qualquer cidadão possa tomar conhecimento das decisões do governo. Muitos municípios já publicam o Diário Oficial exclusivamente em formato eletrônico, disponível no site oficial da Prefeitura ou da Câmara.",
        link: "/legislacao/diariosoficial",
        keywords: ["diario oficial", "o que e diario oficial", "publicacao oficial", "atos municipais", "diario oficial municipal"]
    },
    {
        question: "O que é a Carta de Serviços ao Cidadão?",
        answer: "A Carta de Serviços ao Cidadão é um documento obrigatório para órgãos e entidades do poder público que informam a população sobre os serviços prestados, os canais de acesso, os requisitos, prazos e formas de prestação de cada serviço. Sua elaboração é exigida pelo Decreto Federal nº 9.094/2017 e tem como objetivo facilitar o acesso dos cidadãos aos serviços públicos e estabelecer padrões de qualidade no atendimento. A Carta deve ser disponibilizada no site oficial e atualizada sempre que houver mudanças nos serviços prestados.",
        link: "/carta-de-servico",
        keywords: ["carta de servico", "carta de servicos ao cidadao", "servicos publicos municipais", "atendimento prefeitura", "o que e carta de servico"]
    },
    {
        question: "O que são as secretarias municipais?",
        answer: "As secretarias municipais são órgãos da administração direta da Prefeitura, responsáveis por planejar e executar políticas públicas em áreas específicas como saúde, educação, finanças, obras, meio ambiente, assistência social, entre outras. Cada secretaria é chefiada por um Secretário Municipal, nomeado pelo Prefeito. Elas são o braço operacional da Prefeitura e respondem diretamente ao Prefeito. O cidadão pode contatar a secretaria competente para obter serviços, informações ou registrar demandas relacionadas à sua área de atuação.",
        link: "/secretarias/financas",
        keywords: ["secretaria municipal", "o que e secretaria", "secretario municipal", "estrutura prefeitura", "orgaos prefeitura"]
    },
    {
        question: "O que é o Plano Plurianual (PPA)?",
        answer: "O Plano Plurianual (PPA) é o instrumento de planejamento governamental de médio prazo, com vigência de 4 anos, que estabelece as diretrizes, objetivos e metas da administração pública municipal. Ele organiza as ações do governo em programas com objetivos claros e indica os recursos previstos para cada um deles. O PPA deve ser enviado pelo Prefeito à Câmara Municipal até 31 de agosto do primeiro ano de mandato e sua vigência se estende até o final do primeiro ano do mandato seguinte, garantindo continuidade das políticas públicas entre governos.",
        link: "/transparencia",
        keywords: ["ppa", "plano plurianual", "o que e ppa", "planejamento municipal", "diretrizes governo municipal"]
    },
    {
        question: "O que é o Prefeito Municipal e quais são suas funções?",
        answer: "O Prefeito Municipal é o chefe do Poder Executivo no âmbito municipal, eleito pelo povo para um mandato de 4 anos, podendo ser reeleito uma vez consecutiva. É responsável por administrar o município, executar as leis aprovadas pela Câmara, elaborar e executar o orçamento, coordenar as secretarias e órgãos da Prefeitura, representar o município judicial e extrajudicialmente e promover políticas públicas nas áreas de saúde, educação, infraestrutura, assistência social, entre outras. O Prefeito pode ser responsabilizado por crimes de responsabilidade e responde perante a Câmara Municipal.",
        link: "/prefeitura/prefeito",
        keywords: ["prefeito", "o que e prefeito", "funcao do prefeito", "atribuicoes prefeito", "poder executivo municipal"]
    },
    {
        question: "Como funciona o controle dos gastos públicos municipais?",
        answer: "Os gastos públicos municipais são fiscalizados por diferentes instâncias: internamente, pelo Controle Interno da Prefeitura e da Câmara; externamente, pelo Tribunal de Contas do Estado (TCE), que analisa as contas anuais do Prefeito e da Câmara; pela Câmara Municipal, que fiscaliza o Executivo por meio de requerimentos, CPIs e votação das contas anuais; pelo Ministério Público; e pela própria sociedade civil, por meio do Portal da Transparência e da LAI. O descumprimento das normas financeiras pode resultar em rejeição das contas, multas e até perda do mandato.",
        link: "/transparencia",
        keywords: ["controle gastos publicos", "fiscalizacao prefeitura", "tribunal de contas", "como fiscalizar prefeitura", "controle orcamento municipal"]
    },
];